import React from "react";
import ReactPaginate from "react-paginate";
import classnames from "classnames";

import PerPageCounter from "../selectCountPerPage/selectCountPerPage";

import styles from "./Pagination.module.scss";

export interface IPaginationProps {
  className?: string;
  initialPage?: number;
  marginPagesDisplayed?: number;
  pageCount?: number;
  pageRangeDisplayed?: number;
  onChange: ({ selected }: { selected: number }) => void;
  totalItemsCount?: number;
  showPerPageChoices?: boolean;
  onPerPageChange?: (value) => void;
  onPerPageClear?: () => void;
  perPageValue?: number | string;
  allowClearPerPage?: boolean;
}

export const Pagination: React.FC<IPaginationProps> = ({
  className,
  initialPage,
  marginPagesDisplayed,
  pageCount,
  pageRangeDisplayed,
  onChange,
  totalItemsCount,
  showPerPageChoices = false,
  onPerPageChange,
  onPerPageClear,
  perPageValue,
  allowClearPerPage,
}) => {
  if (pageCount <= 1 && !showPerPageChoices) {
    return "";
  }
  return (
    <div className={classnames(styles.wrapper, className)}>
      <span className={styles.countLabel}>Всего записей: {totalItemsCount}</span>
      <ReactPaginate
        initialPage={initialPage}
        marginPagesDisplayed={marginPagesDisplayed}
        pageCount={pageCount}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={onChange}
        //classes
        containerClassName={`${styles.pagination} `}
        activeClassName={styles.active}
        pageLinkClassName={styles.link}
        breakLinkClassName={styles.breakLink}
        nextLinkClassName={styles.nextLink}
        previousLinkClassName={styles.prevLink}
        pageClassName={styles.pageItem}
        breakClassName={styles.breakItem}
        nextClassName={styles.nextItem}
        previousClassName={styles.prevItem}
        disabledLinkClassName={styles.disabled}
        previousLabel={
          <>
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.33333 4.66675L6 8.00008L9.33333 11.3334V4.66675Z" />
            </svg>
          </>
        }
        nextLabel={
          <>
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66699 11.3334L10.0003 8.00008L6.66699 4.66675V11.3334Z" />
            </svg>
          </>
        }
      />
      {showPerPageChoices && (
        <PerPageCounter
          onChange={onPerPageChange}
          onClear={onPerPageClear}
          value={perPageValue}
          allowClear={allowClearPerPage}
        />
      )}
    </div>
  );
};
